import React from 'react';
import { CheckCircleIcon, ShieldIcon } from 'lucide-react';
export function QuickFactsSection() {
  const facts = [{
    title: 'Outdoor Range Hours',
    detail: 'Members: Monday–Saturday 9:00 AM to Sundown; Sunday 9:00 AM to 5:00 PM. Indoor range available 24/7. Ranges available when no other shooting events are scheduled.'
  }, {
    title: 'Sporting Clays – Public Hours',
    detail: 'Open to the public Saturdays and Sundays, weather permitting, 10:00 AM to 3:00 PM.'
  }, {
    title: 'Deer Season Sight-In Days',
    detail: 'Provided to members and the general public for approximately 3 weeks prior to rifle deer season for a nominal fee.'
  }, {
    title: 'Indoor PPC League',
    detail: 'Sunday mornings and Monday evenings beginning in September; runs approximately 14 weeks ending early April.'
  }, {
    title: 'Indoor Jr. Rifle League',
    detail: 'Tuesday evenings beginning in September and ending early June. Ages 10 to 18. Open to members and non-members.'
  }, {
    title: 'Law Enforcement',
    detail: 'Facilities available to local law enforcement for training, certification, and qualification.'
  }];
  return <section className="w-full py-16 md:py-20" style={{
    backgroundColor: '#ffffff'
  }} aria-label="Quick Facts and Range Rules" data-id="element-1940">
      <div className="max-w-6xl mx-auto px-4 md:px-8" data-id="element-1941">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10" data-id="element-1942">
          <div data-id="element-1943">
            <p className="text-xs font-bold uppercase tracking-widest mb-2" style={{
            color: '#c8a84b',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1944">
              Hours &amp; Information
            </p>
            <h2 className="text-3xl md:text-4xl font-bold uppercase" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-1945">
              Quick Facts
            </h2>
            <div className="section-divider" data-id="element-1946" />
          </div>
          <a href="/RangeRules.html" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg font-semibold text-sm border transition-all hover:bg-forest hover:text-white self-start md:self-auto" style={{
          borderColor: '#1e3d2f',
          color: '#1e3d2f',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-1947">
            <ShieldIcon size={15} data-id="element-1948" />
            Full Range Rules
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1949">
          {facts.map((fact, i) => <div key={i} className="flex items-start gap-4 p-5 rounded-xl" style={{
          backgroundColor: '#f8f6f0',
          border: '1px solid #ede9e0'
        }} data-id="element-1950">
              <CheckCircleIcon size={20} className="flex-shrink-0 mt-0.5" style={{
            color: '#2d5a3d'
          }} data-id="element-1951" />
              <div data-id="element-1952">
                <h3 className="text-sm font-bold uppercase mb-1" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#1e3d2f',
              letterSpacing: '0.03em'
            }} data-id="element-1953">
                  {fact.title}
                </h3>
                <p className="text-sm leading-relaxed" style={{
              color: '#5a5a5a',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-1954">
                  {fact.detail}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}